export default __webpack_public_path__ + "static/media/rs-arte-1.40a35a88.webp";